import * as Yup from 'yup';

// Create a dynamic validation schema based on user role
export const createChangeUserProfileStatusSchema = (userRole?: string) => {
  return Yup.object().shape({
    isApproved: Yup.boolean().required().label("Is Approved"),
    rejectionReason: Yup.string().trim().when('isApproved', {
      is: false, // When 'isApproved' is false
      then: Yup.string().required('Rejection Reason is required').label("Rejection Reason"),
      otherwise: Yup.string().optional().label("Rejection Reason")
    }),
    tradeLicenseExpirationDate: Yup.date()
      .nullable()
      .when('isApproved', {
        is: true, // When 'isApproved' is true
        then: userRole === 'company' 
          ? Yup.date()
              .nullable()
              .required('Company License Expiration Date is required')
              .min(new Date(), 'Expiration date must be in the future')
              .label("Trade License Expiration Date")
          : Yup.date().nullable().optional(),
        otherwise: Yup.date().nullable().optional()
      }),
    brokerLicenseExpirationDate: Yup.date()
      .nullable()
      .when('isApproved', {
        is: true, // When 'isApproved' is true
        then: userRole === 'broker'
          ? Yup.date()
              .nullable()
              .required('Broker License Expiration Date is required')
              .min(new Date(), 'Expiration date must be in the future')
              .label("Broker License Expiration Date")
          : Yup.date().nullable().optional(),
        otherwise: Yup.date().nullable().optional()
      })
  });
};

// Default schema for backward compatibility (both fields optional)
export const changeUserProfileStatus = Yup.object().shape({
  isApproved: Yup.boolean().required().label("Is Approved"),
  rejectionReason: Yup.string().trim().when('isApproved', {
    is: false, // When 'isApproved' is false
    then: Yup.string().required('Rejection Reason is required').label("Rejection Reason"),
    otherwise: Yup.string().optional().label("Rejection Reason")
  }),
  tradeLicenseExpirationDate: Yup.date().nullable().optional(),
  brokerLicenseExpirationDate: Yup.date().nullable().optional()
});